// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.

export const projectedCrossPaths = {
    list:   ()   => 'admin/projected-crosses',
    detail: (id) => `admin/projected-crosses/${id}`,
    // Cola por donadora: bloque aditivo `queues` del stats del animal (Q-255).
    donorQueues: (donorId) => `admin/animals/${donorId}/stats`,
};
